import { render } from "./Notfound.vue?vue&type=template&id=31e03094&scoped=true"
import script from "./Notfound.vue?vue&type=script&lang=js"
export * from "./Notfound.vue?vue&type=script&lang=js"

import "./Notfound.vue?vue&type=style&index=0&id=31e03094&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31e03094"]])

export default __exports__